<template>
  <b-modal
    ref="modal"
    size="md"
    hide-header
    hide-footer
    centered
    @hidden="aoFechar"
  >
    <div class="verificacao-acao">
      <i class="fas fa-shield-halved verificacao-acao__icone"></i>
      <h4 class="verificacao-acao__titulo">{{ titulo }}</h4>
      <p class="verificacao-acao__texto" v-html="descricao"></p>
      <p class="verificacao-acao__canal">{{ instrucaoCanal }}</p>

      <!-- Mesmo componente de dígitos do login e do bloqueio de tela: o
      código é enviado assim que a última caixa é preenchida, então não há
      botão de confirmar. -->
      <FAInput
        :key="inputKey"
        class="verificacao-acao__input"
        @codigo:atualizado="codigo = $event"
        @enter="confirmar"
      />

      <button type="button" class="verificacao-acao__cancelar" @click="fechar">
        Cancelar
      </button>
    </div>
  </b-modal>
</template>

<script>
import ApiService from "@/core/services/api.service";
import FAInput from "../pages/auth/login_pages/2FAInput.vue";

export default {
  name: "ModalVerificacaoAcao",
  components: { FAInput },
  data() {
    return {
      titulo: "",
      descricao: "",
      instrucaoCanal:
        "Abra seu aplicativo autenticador e informe o código atual.",
      codigo: "",
      inputKey: 0,
      resolver: null
    };
  },
  methods: {
    // Devolve uma Promise com o código digitado, ou null se cancelar —
    // assim quem chama trata como uma pergunta simples.
    abrir(titulo, descricao) {
      this.titulo = titulo;
      this.descricao = descricao;
      this.codigo = "";
      this.inputKey++;

      this.dispararCodigo();

      this.$refs.modal.show();

      return new Promise((resolve) => {
        this.resolver = resolve;
      });
    },

    // Quem usa aplicativo autenticador lê o código no app; nos demais
    // canais o backend dispara a mensagem antes de perguntar.
    dispararCodigo() {
      this.instrucaoCanal =
        "Abra seu aplicativo autenticador e informe o código atual.";

      ApiService.post("conta/codigo-acao-sensivel", {})
        .then(({ data }) => {
          if (data.data.enviado) {
            this.instrucaoCanal =
              "Enviamos um código de verificação para o seu canal cadastrado.";
          }
        })
        .catch(() => {
          // Falha ao disparar não impede quem usa app — segue perguntando.
        });
    },

    confirmar() {
      if (!this.codigo || this.codigo.length < 6) return;

      const codigo = this.codigo;
      this.responder(codigo);
      this.$refs.modal.hide();
    },

    fechar() {
      this.$refs.modal.hide();
    },

    // Cancelar (ou fechar no X/ESC) resolve como null.
    aoFechar() {
      this.responder(null);
    },

    responder(valor) {
      if (!this.resolver) return;

      const resolver = this.resolver;
      this.resolver = null;
      resolver(valor);
    },

    // Chamado por quem usa quando o backend recusa o código, para limpar
    // as caixas e permitir nova tentativa sem reabrir o modal.
    limpar() {
      this.codigo = "";
      this.inputKey++;
    }
  }
};
</script>

<style lang="scss" scoped>
.verificacao-acao {
  text-align: center;
  padding: 1rem 0.5rem;
}

.verificacao-acao__icone {
  font-size: 3rem;
  color: #462181;
  margin-bottom: 1rem;
}

.verificacao-acao__titulo {
  font-weight: 700;
  margin-bottom: 0.5rem;
}

.verificacao-acao__texto {
  color: #6a6579;
  font-size: 0.9rem;
  margin-bottom: 0.35rem;
}

.verificacao-acao__canal {
  color: #a1a5b7;
  font-size: 0.8rem;
  margin-bottom: 1.5rem;
}

.verificacao-acao__input {
  margin-bottom: 1rem;
}

.verificacao-acao__cancelar {
  border: none;
  background: none;
  color: #837f95;
  font-size: 0.85rem;
  cursor: pointer;

  &:hover {
    color: #462181;
    text-decoration: underline;
  }
}
</style>
